import I18n from 'I18n';
import { useCallback, useEffect, useRef } from 'react';
import { useSendOnCopilotChannel } from 'copilot-toolkit/channel/hooks/useSendOnCopilotChannel';
import { TOPIC_NAMES } from 'copilot-toolkit/types/Channel';
import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
import { DO_NOT_DISPLAY_THREAD } from 'copilot-toolkit/constants/PromptThread';
const RegenerateButton = ({
  actionButtonObj,
  messageQuery,
  streamingState
}) => {
  var _actionButtonObj$payl;
  const wasStreamingRef = useRef(false);
  const wasSentRef = useRef(false);
  const promptUserForMoreInfo = useSendOnCopilotChannel(TOPIC_NAMES.PROMPT_USER_FOR_MORE_INFO);
  const payloadJsonStringMaybe = actionButtonObj === null || actionButtonObj === void 0 || (_actionButtonObj$payl = actionButtonObj.payload) === null || _actionButtonObj$payl === void 0 ? void 0 : _actionButtonObj$payl.payloadJson;
  let payloadJsonObj;
  try {
    payloadJsonObj = payloadJsonStringMaybe ? JSON.parse(payloadJsonStringMaybe) : undefined;
  } catch (error) {
    consoleIfNotProd.error(`Error parsing payloadJsonString ${error}, payloadJsonStringMaybe -> ${payloadJsonStringMaybe}`);
  }
  const handlePromptUserForMoreInfo = useCallback(() => {
    var _messageQuery$userInp;
    if (!actionButtonObj || !messageQuery || !payloadJsonObj) {
      return;
    }
    promptUserForMoreInfo({
      messageAction: {
        title: 'Generate Actions',
        data: messageQuery !== null && messageQuery !== void 0 ? messageQuery : {}
      },
      messageMetaInfo: {
        source: 'PLUGIN',
        type: 'IN-APP'
      },
      promptData: {
        commandName: 'refine',
        path: ['data', 'userInput'],
        promptPrefix: I18n.text('copilotPlugins.workflowsGenerateActionsPlugin.refinePromptPrefix', {
          originalPrompt: (_messageQuery$userInp = messageQuery === null || messageQuery === void 0 ? void 0 : messageQuery.userInput) !== null && _messageQuery$userInp !== void 0 ? _messageQuery$userInp : ''
        }),
        promptThread: DO_NOT_DISPLAY_THREAD
      }
    });
  }, [actionButtonObj, messageQuery, payloadJsonObj, promptUserForMoreInfo]);
  useEffect(() => {
    if (streamingState === 'streaming') {
      wasStreamingRef.current = true;
    }
    if (wasSentRef.current || !wasStreamingRef.current) {
      return;
    }
    wasSentRef.current = true;
    handlePromptUserForMoreInfo();
  }, [handlePromptUserForMoreInfo, streamingState]);

  // The regenerate button is not rendered in the UI, it is used to trigger
  // the promptUserForMoreInfo action only via the useEffect hook
  return null;
};
export default RegenerateButton;